import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date, formatStr: string = 'dd.MM.yyyy HH:mm') {
  return format(new Date(date), formatStr, { locale: ru })
}

export function formatRelativeDate(date: string | Date) {
  return formatDistanceToNow(new Date(date), { addSuffix: true, locale: ru })
}

export function truncate(str: string, length: number) {
  if (str.length <= length) return str
  return str.slice(0, length) + '...'
}

export function formatNumber(num: number) {
  return new Intl.NumberFormat('ru-RU').format(num)
}

export function formatPercent(value: number, decimals: number = 1) {
  return `${value.toFixed(decimals)}%`
}

export function getInitials(name?: string) {
  if (!name) return '?'
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export function getStatusColor(status: string) {
  switch (status) {
    case 'active':
      return 'badge-green'
    case 'blocked':
      return 'badge-red'
    case 'pending':
      return 'badge-yellow'
    case 'resolved':
      return 'badge-blue'
    case 'archived':
      return 'badge-gray'
    default:
      return 'badge-gray'
  }
}

export function getStatusLabel(status: string) {
  const labels: Record<string, string> = {
    active: 'Активен',
    blocked: 'Заблокирован',
    pending: 'Ожидает',
    deleted: 'Удалён',
    resolved: 'Решён',
    archived: 'Архив',
  }
  return labels[status] || status
}

export function getRoleLabel(role: string) {
  const labels: Record<string, string> = {
    superadmin: 'Суперадмин',
    admin: 'Администратор',
    moderator: 'Модератор',
    support: 'Поддержка',
  }
  return labels[role] || role
}

export function getChatTypeLabel(type: string) {
  const labels: Record<string, string> = {
    quiz: 'Квиз AI',
    support: 'Поддержка',
    private_club: 'Приватный клуб',
  }
  return labels[type] || type
}

export function getLessonTypeLabel(type: string) {
  const labels: Record<string, string> = {
    video: 'Видео',
    article: 'Статья',
    quiz: 'Квиз',
    practice: 'Практика',
  }
  return labels[type] || type
}
